import { useSelector } from 'react-redux';
import { getMediaQueryState } from 'redux/selectors';
import { AccountCircle, Help, ExitToApp } from '@mui/icons-material';
import BookOpenPageVariant from 'mdi-material-ui/BookOpenPageVariant';
import styles from '../welcome.module.css';

const WelcomeLink = (props) => {
	const { isMd } = useSelector(getMediaQueryState);

	const icon = () => {
		if (props.icon === 'lifeBook') {
			return (
				<BookOpenPageVariant
					className={!isMd ? styles.icon : styles.smallIcon}
				/>
			);
		} else if (props.icon === 'profile') {
			return (
				<AccountCircle className={!isMd ? styles.icon : styles.smallIcon} />
			);
		} else if (props.icon === 'support') {
			return <Help className={!isMd ? styles.icon : styles.smallIcon} />;
		} else if (props.icon === 'logout') {
			return <ExitToApp className={!isMd ? styles.icon : styles.smallIcon} />;
		}
	};

	return (
		<div
			className={!isMd ? styles.linkContainer : styles.smallLinkContainer}
			onClick={props.onClick}>
			<div className={styles.iconContainer}>{icon()}</div>
			<div className={!isMd ? styles.textContainer : styles.smallText}>
				{props.name}
			</div>
		</div>
	);
};

export default WelcomeLink;
